module.exports = __webpack_public_path__ + "img/5-sdg-full@2x.9bfa6e7e.png";